(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const isPreCart = urlParams.get('is_pre_cart') === 'true';
  const storedRaw = localStorage.getItem('rc_selected_diamond');

  if (!isPreCart || !storedRaw) return;

  let diamond;
  try { diamond = JSON.parse(storedRaw); } catch (e) { return; }
  if (!diamond) return;

  /* ===== Helper: detect modifier / non-primary clicks =====
     When the user Ctrl/Cmd/Shift/Alt-clicks or middle-clicks a CTA, we bail
     out of our handler and let the browser open the anchor's real href in a
     new tab. Plain left-clicks fall through to the existing logic untouched. */
  function rcIsModifiedClick(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button !== undefined && e.button !== 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const inner = document.querySelector('.product-info-inner');
    const preCart = document.querySelector('.rc-bespoke-pre-cart');
    if (!inner || !preCart) return;

    /* === Hide all default PDP children === */
    Array.from(inner.children).forEach(el => {
      if (!el.classList.contains('rc-bespoke-pre-cart')) {
        el.style.display = 'none';
      }
    });

    /* === Hide installment form === */
    document.querySelectorAll('.product-form').forEach(el => el.style.display = 'none');
    /* === Show pre-cart === */
    preCart.classList.remove('is-hide');

    /* === Helpers === */
    const set = (id, val) => {
      const el = document.getElementById(id);
      if (el) el.textContent = val || '—';
    };

    const carat = parseFloat(diamond.size || 0).toFixed(2);
    const shape = diamond.shape || '—';
    const price = diamond.marked_up_price || diamond.total_sales_price || 0;
    const dims  = diamond.dimensions?.replace(/x/g, ' x ') || (
      diamond.meas_length && diamond.meas_width && diamond.meas_depth
        ? `${parseFloat(diamond.meas_length).toFixed(2)} x ${parseFloat(diamond.meas_width).toFixed(2)} x ${parseFloat(diamond.meas_depth).toFixed(2)}`
        : '—'
    );

    /* === Preserve emerald orientation variant from the URL, if present === */
    const EMERALD_VARIANTS = ['Emerald (North/South)', 'Emerald (East/West)'];
    const effectiveShape = (urlParams.get('shapes') || '')
      .split(',')
      .map(s => s.trim())
      .find(s => EMERALD_VARIANTS.includes(s)) || shape;

    /* === Populate Diamond === */
    set('rc-diamond-title',        `${carat} ${shape} Diamond`);
    set('rc-diamond-price',        `$${Number(price).toLocaleString()}`);
    set('rc-diamond-carat',        carat);
    set('rc-diamond-clarity',      diamond.clarity);
    set('rc-diamond-cut',          diamond.cut || diamond.cut_grade || 'Excellent');
    set('rc-diamond-color',        diamond.color);
    set('rc-diamond-measurements', dims);
    set('rc-diamond-type',         diamond.lg ? 'Lab Grown Diamond' : 'Natural Diamond');
    set('rc-diamond-id',           diamond.cert_num || diamond.diamond_id);

    /* === Populate Setting shape from diamond (passed via localStorage) === */
    set('rc-setting-shape', effectiveShape);

    /* === Compute Total === */
    const settingPriceText = document.querySelector('#rc-setting-price .money')?.innerText || '$0';
    const settingPriceDollars = parseFloat(settingPriceText.replace(/[$,]/g, '')) || 0;
    const total = settingPriceDollars + Number(price);
    set('rc-pre-cart-total', `$${Math.round(total).toLocaleString()}`);

    /* === Inject Ring_Size into cart form properties === */
    const ringSize = urlParams.get('Ring_Size');
    if (ringSize) {
      // Inject into the ring builder's cart form (the hidden properties[...] input)
      const form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        // Remove any stale input first
        form.querySelector('input[name="properties[Ring_Size]"]')?.remove();
        const input = document.createElement('input');
        input.type  = 'hidden';
        input.name  = 'properties[Ring_Size]';
        input.value = ringSize;
        form.appendChild(input);
      }
    }
    set('rc-setting-size', ringSize || '—');

    /* === Update EDIT setting link with Ring_Size param === */
    const editLink = document.getElementById('rc-pre-cart-edit-setting');
    if (editLink && ringSize) {
      const currentUrl = new URL(window.location.href);
      const editUrl = new URL(editLink.href, window.location.origin);
      editUrl.searchParams.set('Ring_Size', ringSize);
      const startWithSetting = currentUrl.searchParams.get('start-with-setting');
      if (startWithSetting !== null) {
        editUrl.searchParams.set('start-with-setting', startWithSetting);
      }
      editLink.href = editUrl.toString();
    }

    /* === Wire CHANGE diamond href === */
    const changeDiamondLink = document.getElementById('rc-pre-cart-change-diamond');
    if (changeDiamondLink && typeof rcBuildSelectDiamondUrl === 'function') {
      const cfg = window.__bespokeProductConfig || {};
      changeDiamondLink.href = rcBuildSelectDiamondUrl(effectiveShape, urlParams.get('variant'), cfg.bespokeProductHandle);
    }

    /* === CHANGE DIAMOND === */
    document.getElementById('rc-pre-cart-change-diamond')?.addEventListener('click', function (e) {
      if (rcIsModifiedClick(e)) return; // let the href open a new tab
      e.preventDefault();
      const bespokeConfigDetails = window.__bespokeProductConfig || {};
      const variant = urlParams.get('variant');
      const handle  = bespokeConfigDetails.bespokeProductHandle;
      rcRedirectToSelectDiamond(effectiveShape, variant, handle);
    });

    /* ===== CHANGE Setting link (pre-cart) ===== */
    const rcChangeSetting = document.querySelector('.rc-pre-cart-change-setting');

    rcChangeSetting?.addEventListener('click', function (e) {
      e.stopImmediatePropagation(); // block the other (delegated) handler routing to the diamond feed
      if (e.metaKey || e.ctrlKey || e.shiftKey) {
        clearBespokeSelectedData();
        return; // new tab opens via the href (ring-builder)
      }
      e.preventDefault();
      clearBespokeSelectedData();
      window.location.href = '/collections/ring-builder?start-with-setting=true';
    }, true); // capture phase, so we run before a bubbling delegated handler
  });
})();